module.exports = __webpack_public_path__ + "static/wpack/extracted/hand-cards602c170114683a4f4deba77925aa6b08.svg";